const { NODE_ENV: env } = process.env;

const baseUrl =
    env === "development"
        ? "http://localhost:8080/v1/"
        : "https://backend.mineralesdetarachi.com/v1/";
export { baseUrl };